export const mimes = {
	MSWORD: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};
